import React from "react";

const ChangePassword = () => {
  return (
    <div className="p-4 bg-card rounded-lg">
      <h2 className="text-xl text-primary pb-5">Change Password</h2>
      <form>
        <div className="flex flex-col gap-2 mb-8">
          <label htmlFor="old_password" className="text-primary">
            Old Password
          </label>
          <input
            type="password"
            id="old_password"
            name="old_password"
            placeholder="old password"
            className="outline-none px-3 py-1 border rounded-md text-primary"
          />
        </div>
        <div className="flex flex-col gap-2 mb-8">
          <label htmlFor="new_password" className="text-primary">
            New Password
          </label>
          <input
            type="password"
            id="new_password"
            name="new_password"
            placeholder="new password"
            className="outline-none px-3 py-1 border rounded-md text-primary"
          />
        </div>
        <div>
          <button className="px-8 py-2 bg-secondary shadow-lg hover:shadow-secondary/30 text-card rounded-md">
            Update
          </button>
        </div>
      </form>
    </div>
  );
};

export default ChangePassword;
